'use strict';

var WritableStream = require('stream').Writable,
  util = require('util');
var DevNullStream = module.exports = function () {
  WritableStream.call(this);
};
util.inherits(DevNullStream, WritableStream);
DevNullStream.prototype._write = function (chunk, encoding, cb) {
  cb();
};